import { memo } from 'react';

import { Builder, withChildren } from '@builder.io/react';
import dynamic from 'next/dynamic';

import { uiImages } from '@/react/components/content/registry/data';

/**
 * Register the AboutPage component.
 * This is a custom About Us page component for Teva.
 */
const register = (): void => {
  const component = memo(dynamic(async () => import('./index')));
  const componentWithChildren = withChildren(component);

  Builder.registerComponent(componentWithChildren, {
    name: 'TevaAboutPage',
    friendlyName: 'About Page Content (Teva)',
    static: true,
    image: uiImages.sectionImage
  });
};

export default register;
